module.exports = __webpack_public_path__ + "media/luxury-2026/loch-front-facade-960-6846806c.jpg";